import { addDays, format } from "date-fns";
import { ja } from "date-fns/locale";

/**
 * 週の開始日（月曜日）から平日範囲の表示テキストを生成する。
 * 例: "4月6日 (月) 〜 10日 (金)" or "3月31日 (月) 〜 4月4日 (金)"
 */
export function formatWeekRange(weekStart: Date): string {
  const weekFriday = addDays(weekStart, 4);
  const fmt = (d: Date, p: string) => format(d, p, { locale: ja });

  const startStr = fmt(weekStart, "M月d日 (E)");

  if (weekStart.getMonth() === weekFriday.getMonth()) {
    return `${startStr} 〜 ${fmt(weekFriday, "d日 (E)")}`;
  }
  return `${startStr} 〜 ${fmt(weekFriday, "M月d日 (E)")}`;
}
